/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "../Alert";
import BaseCom from "../BaseCom";
import LoadingAlert from "../LoadingAlert";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import FormInput from "../FormInput";
import { SidebarGlobal } from "../_Sidebar";
import Auth from "../../shared/Auth";
import DataTable from "../DataTable";
import { qreq } from "../../shared/qrequest";
import L from "../Lang";
import Icon from "../Icon";
import { Pop } from "../PopModal";

class InventoryBoxList extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: []
        };
    }

    async componentDidMount() {
        await this.load();
    }


    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {
        this.setState({ loading: true });
        try {
            let j = await qreq.getAsync('/api/inventory/box/list');
            if (j.list) {
                this.setState({ list: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ loading: false, loaded: true });
    }

    delete = async (row) => {
        Pop.showConfirm(<><L>Are you sure you want to delete</L> <b>{row.name}</b><L>?</L></>, <L>Delete Box</L>, async () => {
            try {
                let j = await qreq.postAsync('/api/inventory/box/delete', row);
                if (j.errorCode === 0) {
                    this.success('Deleted!');
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    render() {
        const header = (<h1><L>Boxes</L></h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />


        const columns = [
            /*{ icon: 'Eye' , link: !Auth.hasRole('readonly') && '/inventory/box/:id' },*/
            {
                name: 'delete', valueFunc: row => <Icon icon="faTrash" role="button" onClick={() => this.delete(row)} className="text-danger" />,
                width: '50px'
            },
            { name: 'id', width: '100px', title: 'ID'/*, link: !Auth.hasRole('readonly') && '/inventory/box/:id', */, className: 'd-none d-md-table-cell' },
            { name: 'name', title: 'Box Name'/*, link: !Auth.hasRole('readonly') && '/inventory/box/:id'*/ },
            { name: 'itemCount', title: 'Items', valueFunc: row => row.itemCount ? String(row.itemCount) : 'Empty' },
            { name: 'createdDate', title: 'Created', format: 'datetime', className: 'd-none d-md-table-cell' }
        ];

        return <div className="container-fluid">
            {header}
            <Alert type="info"><L>This area is under construction.</L></Alert>
            <form onSubmit={this.search} className="d-none">
                <div className="mb-3">
                    <FormInput model={this.state.query} name="search" label="Search for a box..." labelAsPlaceholder onChange={this.search} />
                </div>
            </form>
            <div className="mt-2 pb-3">
                <DataTable columns={columns} data={this.state.list} totalCount={this.state.totalCount} />
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(InventoryBoxList);